var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 46.5,
    height: 34.5,
    rx: 5.25,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 46.5,
    height: 34.5,
    rx: 5.25,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.585 12.434c.41-.52.688-1.22.615-1.934-.6.03-1.334.402-1.758.923-.38.446-.718 1.175-.63 1.86.674.059 1.348-.343 1.773-.849zm.607.982c-.979-.06-1.811.564-2.279.564-.467 0-1.183-.534-1.957-.52-1.008.015-1.943.593-2.454 1.513-1.052 1.84-.278 4.569.745 6.067.497.742 1.095 1.558 1.884 1.529.745-.03 1.037-.49 1.943-.49.905 0 1.168.49 1.957.475.818-.015 1.33-.742 1.826-1.484.57-.845.804-1.661.818-1.706-.014-.015-1.577-.623-1.592-2.448-.015-1.527 1.227-2.254 1.286-2.299-.702-1.053-1.797-1.171-2.177-1.201zM22.952 11.35c2.128 0 3.61 1.488 3.61 3.654 0 2.175-1.513 3.671-3.663 3.671h-2.356v3.802h-1.702V11.349h4.111zm-2.409 5.875h1.953c1.482 0 2.325-.81 2.325-2.213s-.843-2.205-2.317-2.205h-1.96v4.418zm6.44 2.946c0-1.427 1.072-2.244 3.047-2.367l2.12-.131v-.617c0-.902-.585-1.396-1.626-1.396-.858 0-1.482.447-1.61 1.134h-1.536c.046-1.443 1.383-2.491 3.192-2.491 1.945 0 3.214 1.033 3.214 2.637v5.537H32.21v-1.334h-.038c-.448.871-1.436 1.419-2.508 1.419-1.58 0-2.682-.957-2.682-2.39zm5.167-.717v-.625l-1.892.124c-1.063.07-1.618.47-1.618 1.172 0 .678.577 1.118 1.482 1.118 1.154 0 2.028-.748 2.028-1.789zm3.08 6V24.12c.106.015.364.03.501.03.753 0 1.178-.323 1.436-1.156l.152-.494-2.88-8.097h1.779l2.005 6.57h.038l2.006-6.57H42l-2.986 8.506c-.684 1.95-1.467 2.591-3.123 2.591-.13 0-.547-.015-.661-.046z",
    fill: "#000"
  })));
}
export default SvgApplePay;